import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { XIcon, CheckIcon, ExclamationIcon } from '@heroicons/react/solid';
import useErrorStore from '../../zustand/error';

export type LevelStyling = {
  textColor: string;
  bgColor: string;
  iconColor: string;
  Icon: any;
};

export enum Levels {
  error = 'error',
  warning = 'warning',
  success = 'success',
}

export const levels: Record<Levels, LevelStyling> = {
  [Levels.error]: {
    Icon: XIcon,
    textColor: 'text-white',
    bgColor: 'bg-red-500',
    iconColor: 'text-red-500',
  },
  [Levels.warning]: {
    Icon: ExclamationIcon,
    textColor: 'text-white',
    bgColor: 'bg-yellow-400',
    iconColor: 'text-yellow-400',
  },
  [Levels.success]: {
    Icon: CheckIcon,
    textColor: 'text-white',
    bgColor: 'bg-green-400',
    iconColor: 'text-green-400',
  },
};

export default function Toast() {
  const { errors, popError } = useErrorStore();

  useEffect(() => {
    setTimeout(() => {
      if (!errors.length) return;
      popError();
    }, errors.length * 3000);
  }, [errors]);

  if (!errors.length) return <></>;
  const error = errors[errors.length - 1];
  const { textColor, bgColor, iconColor, Icon } = levels[error.level];

  return (
    <div className="w-full flex justify-center fixed bottom-4">
      <div
        className={clsx(
          'flex items-center mx-8 p-4 mb-4 text-gray-500 rounded-md shadow-lg',
          bgColor,
          textColor
        )}
        role="alert"
      >
        <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500 bg-white rounded-md dark:bg-green-800 dark:text-green-200">
          <Icon className={clsx('w-5', iconColor)} />
        </div>
        <div className="ml-3 text-md font-medium text-white">
          {error.message}
        </div>
      </div>
    </div>
  );
}

Toast.propTypes = {
  level: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};
